__webpack_require__.j = "public-favorite-share";